const collection = {
  slug: "comme-des-garcons-2012aw-2-dimensions-guide",
  metaTitle:
    "コムデギャルソン名作 2 Dimensionsとは｜2012AW平面的な服と買取ガイド",
  metaDescription:
    "COMME des GARÇONS 2012AW『2 Dimensions』を解説。服を立体物ではなく紙や絵のように扱い、身体の上に別の平面世界を乗せた川久保玲の名作コレクション。コムデギャルソン名作、アーカイブ価値、買取相談までEnclopediaが詳しく案内します。",
  metaKeywords:
    "コムデギャルソン 2 Dimensions,COMME des GARCONS 2012AW,COMME des GARCONS 2 Dimensions,コムデギャルソン 名作,コムデギャルソン 平面的な服,コムデギャルソン 2012AW,川久保玲 名作,COMME des GARCONS Fall 2012,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン 高価買取,コムデギャルソン 古着 買取,コムデギャルソン レディース 買取,Enclopedia,アンクロペディア",
  canonicalPath:
    "/archive_collection/comme-des-garcons-2012aw-2-dimensions-guide",
  heroImage: "media/archive_fashion/archive11.png",
  heroImageAlt:
    "COMME des GARÇONS 2012AW 2 Dimensions 平面的な服を解説するEnclopediaアーカイブガイド画像",
  heroNumber: "12 / 2 DIMENSIONS",
  label: "ARCHIVE COLLECTION STUDY",
  title: "COMME des GARÇONS 2012AW『2 Dimensions』",
  lead: "COMME des GARÇONS 2012AW『2 Dimensions』。\n\n服を立体物ではなく、まるで紙や絵のように扱ったコレクションです。\n身体に沿う服ではなく、身体の上に別の平面世界を乗せるような発想。\n\n服は本来、身体という立体に合わせて作られます。\n肩、胸、腰、腕、脚。\nしかしこのシーズンの川久保玲は、その前提をあえて外しました。\n\n服が身体を包むのではなく、身体の前に立ちはだかる。\n服が身体の曲線をなぞるのではなく、紙のような平面として存在する。\nそれが『2 Dimensions』の強さです。",
  keywordLine: [
    "2 dimensions",
    "flat clothes",
    "rei kawakubo",
    "buyback guide",
  ],
  thesis:
    "2012AW『2 Dimensions』の重要性は、服を身体に沿わせる立体物としてではなく、紙や絵のような平面世界として身体の上に置いた点にあります。",
  whyTitle: "なぜ『2 Dimensions』は、平面的なのに強く見えるのか。",
  whyBody:
    "一般的な服は、身体の立体に合わせて作られます。\n肩を作り、胸や腰の丸みに沿い、動きやすさを確保しながら、身体を美しく整える。\nつまり服は、身体という三次元の存在に従うものとして考えられてきました。\n\nしかしCOMME des GARÇONS 2012AW『2 Dimensions』は、その前提を反転させます。\n身体に沿うのではなく、身体の上に平面を乗せる。\n服を布の彫刻ではなく、切り絵、紙人形、絵画、記号のように扱う。\n\nVogue Runwayでも、このシーズンは“The future's in two dimensions”という前提で語られ、紙人形のような平面性やフェルトのコートドレスが印象的に紹介されています。\n\nこのコレクションが名作として残るのは、奇抜だからではありません。\n服は必ず身体に沿うべきなのか。\n服は立体でなければならないのか。\n身体の上に、別の視覚世界を置くことはできないのか。\nそうした問いを、非常に明快な形で提示したからです。\n\nEnclopediaでは、このような名作の文脈を入口に、コムデギャルソンのアーカイブ価値を読み取り、買取やレンタルを通じて次のユーザーへつなげます。",
  pillars: [
    {
      number: "01",
      title: "FLATNESS AS IDEA",
      text: "2 Dimensionsの平面性は、単なるシルエットの遊びではありません。服を身体に沿わせるという前提を疑い、紙や絵のような存在として扱う思想です。",
    },
    {
      number: "02",
      title: "BODY AS BACKGROUND",
      text: "このコレクションでは、身体は服を成立させる立体というより、平面世界を乗せる背景のように扱われます。身体よりも服の記号性が前に出ます。",
    },
    {
      number: "03",
      title: "ARCHIVE AS VALUE",
      text: "COMME des GARÇONSの名作は、古い服だから価値があるのではありません。時間が経っても問いが残り、今も読み直せるからアーカイブとして評価されます。",
    },
  ],
  readingTitle: "平面、紙人形、切り絵、身体から読む『2 Dimensions』。",
  readingIntro:
    "このコレクションは、ただ服が大きいから印象的なのではありません。なぜ身体の立体感を消すのか、なぜ紙のように見せるのか、なぜ平面が服として成立するのかを見ることで、川久保玲の発想の強さが見えてきます。",
  observations: [
    {
      index: "01",
      title: "服を、身体に沿うものから切り離した",
      text: "通常、服は身体に合わせて作られます。\n肩線、アームホール、ウエスト、ヒップ。\n服の構造は、身体の立体を前提にしています。\n\nしかし2 Dimensionsでは、その立体への従属が弱められます。\n服は身体を包むものではなく、身体の前に置かれる平面のように見える。\n\n身体が主役で服が補助するのではなく、服の平面性そのものが主役になる。\nここに、このコレクションの根本的な転換があります。",
    },
    {
      index: "02",
      title: "紙人形のような服が、ファッションの見方を変える",
      text: "Vogue Runwayでは、このコレクションの服が紙人形のような感覚を持つものとして語られています。\n紙人形は、身体に立体的に沿うものではありません。\n平らな服を、平らな身体の上に重ねる遊びです。\n\n川久保玲は、その感覚をランウェイへ持ち込みました。\n服は身体にぴったり合わなくてもいい。\n服は立体的に作り込まれなくてもいい。\n平面のまま、身体の上に存在してもいい。\n\nこの発想は、ファッションを“着る彫刻”ではなく、“着るイメージ”として見せています。",
    },
    {
      index: "03",
      title: "フェルトの厚みが、平面を強いオブジェにした",
      text: "2 Dimensionsでは、フェルトのような厚みのある素材感が重要です。\n薄い紙のような平面ではなく、厚みのある平面。\nそのため、服は軽いイラストのようでありながら、同時に強いオブジェとして立ち上がります。\n\n身体に沿わないのに、存在感は強い。\n立体的に縫い込まれていないように見えるのに、視覚的には非常に強い。\n\nこの矛盾が、2 Dimensionsの面白さです。",
    },
    {
      index: "04",
      title: "花柄や色彩が、平面世界をさらに強調した",
      text: "このシーズンでは、鮮やかな色や大きな花柄も印象的です。\n通常、花柄は服の表面に乗る装飾として扱われます。\nしかし2 Dimensionsでは、花柄そのものが服の形と一体化し、まるで大きな絵や切り抜きのように見えます。\n\n身体の曲線に沿って柄が流れるのではなく、平面の上に強く置かれる。\nその結果、服は身体のための布ではなく、身体の上に置かれた視覚イメージになります。",
    },
    {
      index: "05",
      title: "身体を美しく見せるより、身体を記号の背景にする",
      text: "多くの服は、身体を美しく見せるために設計されます。\nしかし2 Dimensionsでは、身体そのものの美しさは後ろに下がります。\n身体は、平面の服を支える背景のような存在になります。\n\nこれは身体を否定しているのではありません。\nむしろ、身体と服の関係を別の角度から見直しているのです。\n服は身体に従うだけではなく、身体の上に別の世界を作ることができる。\nこの発想が、COMME des GARÇONSらしい強さです。",
    },
    {
      index: "06",
      title: "2 Dimensionsは、デジタル時代の服の見え方も先取りしていた",
      text: "このコレクションが面白いのは、服を平面として扱った点です。\n現代では、服は実物としてだけでなく、画面上の画像として大量に見られます。\n正面写真、SNS、EC、ルック画像。\n服は三次元の物体でありながら、同時に二次元のイメージとして消費されます。\n\n2 Dimensionsは、その状況を先取りしているようにも見えます。\n服が身体に沿うかどうかよりも、イメージとしてどれだけ強く立ち上がるか。\nEnclopediaでは、この視点を、アーカイブを読む現代的な入口として扱います。",
    },
    {
      index: "07",
      title: "買取で見るべきなのは、古さではなく文脈",
      text: "コムデギャルソンの買取では、単に古い服だから価値がある、という見方では不十分です。\nどのシーズンか。どのラインか。どんなテーマと接続しているか。どれだけブランド史の中で重要か。\n\n2012AW『2 Dimensions』のような象徴的コレクションは、まさに文脈が価値になる代表例です。\nEnclopediaでは、コムデギャルソンの服を単なる古着としてではなく、ブランドの思想やコレクション背景まで含めて確認します。",
    },
  ],
  quote:
    "2 Dimensionsは、服を身体に合わせるのではなく、身体の上に別の平面世界を立ち上げたコレクションです。",
  perspectiveTitle:
    "Enclopediaは、コムデギャルソンを“古着”ではなく“問いが残るアーカイブ”として見る。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text: "2012AW『2 Dimensions』を、平面性、紙人形、切り絵、身体と服の関係、川久保玲の思想から読み解きます。",
    },
    {
      number: "02",
      title: "SERVICE ENTRY",
      text: "この記事は、コムデギャルソンの名作を知る入口であると同時に、Enclopediaが服をどのように読み、扱い、次へつなげるサービスなのかを知ってもらう入口です。",
    },
    {
      number: "03",
      title: "BUYBACK",
      text: "買取対象は2012AWだけに限定しません。COMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全般を文脈込みで相談対象として見ます。",
    },
  ],
  experienceTitle:
    "コムデギャルソンを売る前に、その一着がどの文脈にあるかを確認する。",
  experienceBody:
    "コムデギャルソンの買取では、ブランド名だけでなく、ライン、年代、シーズン、デザイナー、素材、状態、現在の需要が重要です。\n今回の記事では2012AW『2 Dimensions』を中心に解説していますが、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、COMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSなど、コムデギャルソン全般を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n名作コレクションを知ることは、自分の持っている一着の価値を見直す入口になります。",
  experienceItems: [
    "COMME des GARÇONSのライン名を確認する",
    "タグ・品質表示・年代・シーズンが分かる写真を撮影する",
    "平面的なシルエット、フェルト素材、大きな花柄、切り絵的な造形を確認する",
    "HOMME PLUS、JUNYA、noirなどラインごとの特徴を確認する",
    "2012AWなど名作シーズンに近い文脈があるか確認する",
    "シーズンや価値が分からない場合もLINEで写真を送る",
  ],
  archiveItemsTitle: "コムデギャルソンの名作を入口に、買取相談へつなげる。",
  archiveItemsBody:
    "Enclopediaでは、コムデギャルソンを単なるブランド古着としてではなく、コレクション背景、ライン、年代、思想、現在の需要まで含めて見ています。この記事で2012AW 2 Dimensionsの重要性に触れた方は、所有しているコムデギャルソンの一着も、まずはLINEでご相談ください。",
  archiveItems: [
    {
      label: "BUYBACK FOCUS 01",
      title: "コムデギャルソン買取ページへ",
      productPath: "/brand_buyback/comme-des-garcons",
      productImage: "",
      text: "COMME des GARÇONS、HOMME PLUS、HOMME、JUNYA WATANABE、noir kei ninomiyaまで。コムデギャルソン全般の買取対象と査定視点を確認できます。",
    },
    {
      label: "BUYBACK FOCUS 02",
      title: "LINEでコムデギャルソンを事前査定",
      productPath: "https://line.me/R/ti/p/@240yzqkh",
      productImage: "",
      text: "タグ、品質表示、全体写真、ディテール写真を送るだけで、宅配買取へ進む前におおまかな査定方向を確認できます。シーズンが分からない場合も相談可能です。",
    },
    {
      label: "SERVICE FOCUS 03",
      title: "Enclopediaのアーカイブレンタルを見る",
      productPath: "/",
      productImage: "",
      text: "Enclopediaは買取だけでなく、アーカイブを次の人が体験できるレンタルサービスです。服を所有物ではなく、文化として循環させます。",
    },
  ],
  finalCta: {
    title:
      "2 Dimensionsの記事を読んだら、次はEnclopediaでコムデギャルソンの価値を相談する。",
    body: "COMME des GARÇONS 2012AW『2 Dimensions』は、コムデギャルソンの名作を知るための強い入口です。\nただし、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaまで、コムデギャルソン全般の価値をアーカイブの視点で確認します。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
    buttonLabel: "コムデギャルソンをLINEで事前査定する",
    buttonHref: "https://line.me/R/ti/p/@240yzqkh",
  },
};

export default collection;
